import { PLATFORM_ADMIN_HUB } from './platform-admin-hub.definition.js';
import { PORTFOLIO_MANAGEMENT_ADMIN_HUB, PORTFOLIO_MANAGEMENT_DATA_HUB, PORTFOLIO_MANAGEMENT_ORGANIZATION_ADMIN_HUB, } from './portfolio-management-v1-hubs.js';
import { ROUTE_IDS } from '../routes/ids.js';
export const HUB_REGISTRY = Object.freeze({
    [ROUTE_IDS.DATA_HUB]: PORTFOLIO_MANAGEMENT_DATA_HUB,
    [ROUTE_IDS.ADMIN_HUB]: PORTFOLIO_MANAGEMENT_ADMIN_HUB,
    [ROUTE_IDS.PLATFORM_ADMIN_HUB]: PLATFORM_ADMIN_HUB,
    [ROUTE_IDS.ORGANIZATION_ADMIN_HUB]: PORTFOLIO_MANAGEMENT_ORGANIZATION_ADMIN_HUB,
});
export function getHubDefinition(routeId) {
    return HUB_REGISTRY[routeId];
}
export function getHubByRouteId(routeId) {
    return HUB_REGISTRY[routeId];
}
